module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1016-7ebd37c00e9ff865cb607745eea8e689.png";